"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringManipulation = void 0;
var StringManipulation;
(function (StringManipulation) {
    /**
     * Splits a string into HTML paragraphs using `$-0` as a delimiter.
    *
    * Each occurrence of `$-0` is treated as a paragraph break.
    * The delimiter is removed, each segment is trimmed, empty segments are ignored,
    * and the remaining text is wrapped in `<p>` tags.
    *
    * @param input - The input string containing `$-0` paragraph delimiters.
    * @param spaces - Optional spacing (in pixels) between paragraphs.
    * @returns A single HTML string with each paragraph wrapped in `<p>` tags.
    *
    * @example
    * splitToParagraphs("Hello$-0World", 8);
    * // returns: '<p style="margin-bottom:8px;">Hello</p><p>World</p>'
    */
    function splitToParagraphs(input, spaces = 0) {
        if (!input)
            return '';
        const parts = input
            .split('$-0')
            .map((part) => part.trim())
            .filter(Boolean);
        return parts
            .map((part, index) => {
            const isLast = index === parts.length - 1;
            const style = !isLast && spaces > 0 ? ` style="margin-bottom:${spaces}px;"` : '';
            return `<p${style}>${part}</p>`;
        })
            .join('');
    }
    StringManipulation.splitToParagraphs = splitToParagraphs;
})(StringManipulation || (exports.StringManipulation = StringManipulation = {}));
